import React from 'react';
import './ProductoCard.css'; // Usar los mismos estilos base

/**
 * Versión extendida de ProductoCard para mostrar información de ingredientes
 */
const ProductoCardConIngrediente = ({
  producto,
  onAgregarProducto,
  onVerDetalles,
  ingredienteEncontrado,
  esExcluido
}) => {
  // Clases adicionales basadas en la búsqueda de ingredientes
  const clasesAdicionales = esExcluido
    ? 'resultado-sin-ingrediente'
    : (ingredienteEncontrado ? 'resultado-ingrediente' : '');

  return (
    <div
      className={`producto-card ${clasesAdicionales}`}
      onClick={() => onAgregarProducto(producto)}
    >
      <div className="producto-info">
        <h3 className="producto-nombre">{producto.nombre}</h3>
        <div className="producto-precio">
          ${parseFloat(producto.precio).toFixed(2)}
        </div>

        {/* Mostrar el ingrediente encontrado */}
        {ingredienteEncontrado && !esExcluido && (
          <div className="ingrediente-match">
            Contiene: {ingredienteEncontrado}
          </div>
        )}

        {/* Mostrar información para ingredientes excluidos */}
        {esExcluido && (
          <div className="ingrediente-excluido">
            No contiene este ingrediente
          </div>
        )}
      </div>

      <button
        className="ver-detalles-btn"
        onClick={(e) => onVerDetalles(e, producto)}
      >
        <i className="info-icon">i</i>
      </button>
    </div>
  );
};

export default ProductoCardConIngrediente;